import * as angular from "angular";
import {IController, IQService} from "angular";
import * as _ from "lodash";
import {DeliveriesRequestsService} from "../../../deliveries/services/deliveries-requests.service";


export class SiteOverviewCtrl implements IController {
  site: any;
  from: any;
  to: any;

  public rows: any = [];
  public loading: boolean = false;
  public pieEnabled: boolean = false;
  public pieChart: any = {};
  public totalDeliveries: number = 0;

  constructor(private deliveriesRequestsService: DeliveriesRequestsService, private $q: IQService, private $log, private $filter, private $translate) {
  }

  $onInit() {
    this._loadDeliveriesTotals(this.from, this.to, undefined, this.site.id).then((totals) => {
      this._initPieChart(totals);
    });
  };

  $onChanges(changes) {
    if (changes.from && !changes.from.isFirstChange() ||
      changes.to && !changes.to.isFirstChange()) {
      this._loadDeliveriesTotals(this.from, this.to, undefined, this.site.id).then((totals) => {
        this._initPieChart(totals);
      });
    }
  };

  private _loadDeliveriesTotals(totalsFrom, totalsTo, totalsServiceAreaIds, siteId) {
    const deferred = this.$q.defer();
    this.pieEnabled = false;
    this.pieChart = {};
    this.rows = [];
    this.totalDeliveries = 0;
    this.loading = true;
    this.deliveriesRequestsService.getTotalsOverviewBySiteId(totalsFrom, totalsTo, siteId)
      .then((_totals: any) => {
        if (_totals.total) {
          this.totalDeliveries = _totals.total;
          // _.unset(_totals, 'total');
        }
        deferred.resolve(this._filterTotals(_totals))
      })
      .catch((error) => {
        if (error) {
          deferred.reject();
          this.$log.error('Failed to get totals @siteOverview@_loadDeliveriesTotals', error);
        }
      })
      .finally(() => {
        this.loading = false;
      });

    return deferred.promise;
  }

  private _initPieChart(totals) {
    let availableDataRowsCount = 0;
    _.forOwn(totals, (statusVal, statusKey) => {
      if (availableDataRowsCount < _.toNumber(statusVal)) {
        availableDataRowsCount++
      }
      this.rows.push(
        {
          c: [
            {v: this._getHeader(statusKey)},
            {v: statusVal}
          ]
        }
      )
    });

    this.pieChart = this._getPieCharts(this.rows);
    this.pieEnabled = availableDataRowsCount > 0;
  }


  private _getPieCharts(rows) {
    return {
      type: 'PieChart',
      options: {
        title: 'Deliveries Overview',
        pieHole: 0.45,
        fontSize: 16,
        fontName: 'RobotoDraft',
        colors: ['#4B81A7', '#2C82BE', '#53A8E2', '#76DDFB', '#C2D3DF', '#E2F3FF'],
        height: 350,
        chartArea: {left: 0, top: 10, width: '90%', height: '90%'},
        legend: {
          position: 'left',
          textStyle: {color: 'rgba(0, 0, 0, 0.87)', fontSize: 16}
        }
        // is3D: true
      },
      data: {
        cols: [
          {id: "t", label: "Status", type: "string"},
          {id: "s", label: "Total", type: "number"}
        ],
        rows: rows
      }
    };
  }

  private _getHeader(header) {
    var lang = this.$translate.use();
    var translatedHeader = this.$filter('translate')(header);
    if (lang === 'he') {
      translatedHeader = translatedHeader.split("").reverse().join("");
    }
    return translatedHeader;
  }

  private _filterTotals(totals) {
    return _.pickBy(totals, (value, key) => {
      return value > 0 &&
        (
          key === 'unAssigned' ||
          key === 'assigned' ||
          key === 'started' ||
          key === 'aborted' ||
          key === 'canceled' ||
          key === 'completed'
        );
    })
  }


}

angular
  .module('bringoz.admin.organizations')
  .component('siteOverview', {
    bindings: {
      site: '<',
      from: '<',
      to: '<'
    },
    template: require('./site-overview.html').default,
    controller: SiteOverviewCtrl
  });
